{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit TMS.TMSFNCValue;

interface

uses
  Classes, SysUtils, Rtti, Math;

type
  {$IFNDEF WEBLIB}
  TTMSFNCValue = TValue;
  {$ELSE}
  TTMSFNCValue = JSValue;
  {$ENDIF}
  TTMSFNCValueHelper = record helper for TTMSFNCValue
  public
    function Equals(const Value : TTMSFNCValue; AFormatSettings: TFormatSettings) : boolean;
  end;

function TValueToFNCValue(AValue: TValue): TTMSFNCValue;
function FNCValueToTValue(AValue: TTMSFNCValue): TValue;
function TypeOfValue(AValue: TTMSFNCValue): TTypeKind;
function ValueIsEmpty(AValue: TTMSFNCValue): Boolean;
function ValueIsFloat(AValue: TTMSFNCValue): Boolean;
function ValueIsDateTime(AValue: TTMSFNCValue): Boolean; overload;
function ValueIsDateTime(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): Boolean; overload;
function ValueIsDateTimeType(AValue: TTMSFNCValue): Boolean;
function ValueIsInteger(AValue: TTMSFNCValue): Boolean;
function ValueIsString(AValue: TTMSFNCValue): Boolean;
function ValueToBoolean(AValue: TTMSFNCValue): Boolean; overload;
function ValueToBoolean(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): Boolean; overload;
function ValueToDateTime(AValue: TTMSFNCValue): TDateTime; overload;
function ValueToDateTime(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): TDateTime; overload;
function ValueToFloat(AValue: TTMSFNCValue): Double; overload;
function ValueToFloat(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): Double; overload;
function ValueToInt64(AValue: TTMSFNCValue): Int64; overload;
function ValueToInt64(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): Int64; overload;
function ValueToInteger(AValue: TTMSFNCValue): Integer; overload;
function ValueToInteger(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): Integer; overload;
function ValueToString(AValue: TTMSFNCValue): string; overload;
function ValueToString(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): string; overload;
function IsFNCValueEqual(AValue1: TTMSFNCValue; AValue2: TTMSFNCValue; ATypeKind: TTypeKind = tkUnknown): Boolean; overload;
function IsFNCValueEqual(AValue1: TTMSFNCValue; AValue2: TTMSFNCValue; AFormatSettings:TFormatSettings; ATypeKind: TTypeKind = tkUnknown): Boolean; overload;
function CompareFNCValue(AValue1: TTMSFNCValue; AValue2: TTMSFNCValue; ATypeKind: TTypeKind = tkUnknown): Integer; overload;
function CompareFNCValue(AValue1: TTMSFNCValue; AValue2: TTMSFNCValue; AFormatSettings:TFormatSettings; ATypeKind: TTypeKind = tkUnknown): Integer; overload;
function TextToFNCValue(AValueText: string): TTMSFNCValue; overload;
function TextToFNCValue(AValueText: string; AFormatSettings:TFormatSettings): TTMSFNCValue overload;
//procedure TextToFNCValue(AValueText: string; AFormatSettings:TFormatSettings; var AValue: TTMSFNCValue); overload;
//procedure TextToFNCValue(AValueText: string; var AValue: TTMSFNCValue); overload;
function FNCValueToString(AValue: TTMSFNCValue): string; overload;
function FNCValueToString(AValue: TTMSFNCValue; AFormatSettings:TFormatSettings): string; overload;

implementation

uses
  System.TypInfo, DateUtils;

function TValueToFNCValue(AValue: TValue): TTMSFNCValue;
begin
  {$IFDEF WEBLIB}
  Result := AValue.AsJSValue;
  {$ELSE}
  Result := AValue;
  {$ENDIF}
end;

function FNCValueToTValue(AValue: TTMSFNCValue): TValue;
begin
  {$IFDEF WEBLIB}
  if Assigned(AValue) then
    Result := TValue.FromJSValue(AValue)
  else
    Result := TValue.Empty;
  {$ELSE}
  Result := AValue;
  {$ENDIF}
end;

function ValueToInteger(AValue: TTMSFNCValue): Integer;
begin
  Result := ValueToInteger(AValue, FormatSettings);
end;

function ValueToInteger(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): Integer;
var
  v: Int64;
begin
  Result := 0;
  v := ValueToInt64(AValue, AFormatSettings);
  if (v <= MaxInt) and (v >= -MaxInt) then
    Result := v;
end;

function ValueToInt64(AValue: TTMSFNCValue): Int64;
begin
  Result := ValueToInt64(AValue, FormatSettings);
end;

function ValueToInt64(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): Int64;
var
  I64: Int64;
  I: Integer;
  D: Double;
  v: TValue;
  B: Boolean;
begin
  Result := 0;

  v := FNCValueToTValue(AValue);
  if v.IsEmpty then
    Exit;

  case v.Kind of
    tkEnumeration:
    begin
      if v.TryAsType<Boolean>(B) then
        Result := Integer(B)
    end;
    tkInteger:
    begin
      if v.TryAsType<Integer>(I) then
        Result := I
    end;
    {$IFNDEF WEBLIB}
    tkInt64:
    begin
      if v.TryAsType<Int64>(I64) then
        Result := I64
    end;
    {$ENDIF}
    tkFloat:
    begin
      if v.TryAsType<Double>(D) then
        Result := Round(D);
    end;
    {$IFDEF WEBLIB}
    tkBool:
    begin
      if v.TryAsType<Boolean>(B) then
        Result := Integer(B);
    end;
    {$ENDIF}
    tkString{$IFNDEF WEBLIB}, tkWString, tkLString, tkUString{$ENDIF}:
    begin
      if TryStrToInt(v.AsString, I) then
        Result := I
      else if TryStrToInt64(v.AsString, I64) then
        Result := I64
      else if TryStrToFloat(v.AsString, D, AFormatSettings) then
        Result := Round(D)
      else if TryStrToBool(v.AsString, B) then
        Result := Integer(B);
    end;
  end;
end;

function ValueToBoolean(AValue: TTMSFNCValue): Boolean;
begin
  Result := ValueToBoolean(AValue, FormatSettings);
end;

function ValueToBoolean(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): Boolean;
begin
  Result := ValueToInteger(AValue, AFormatSettings) <> 0;
end;

function ValueToFloat(AValue: TTMSFNCValue): Double;
begin
  Result := ValueToFloat(AValue, FormatSettings);
end;

function ValueToFloat(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): Double;
var
  I64: Int64;
  I: Integer;
  D: Double;
  v: TValue;
  B: Boolean;
begin
  Result := 0.0;

  v := FNCValueToTValue(AValue);
  if v.IsEmpty then
    Exit;

  case v.Kind of
    tkEnumeration:
    begin
      if v.TryAsType<Boolean>(B) then
        Result := Integer(B)
    end;
    tkInteger:
    begin
      if v.TryAsType<Integer>(I) then
        Result := I
    end;
    {$IFNDEF WEBLIB}
    tkInt64:
    begin
      if v.TryAsType<Int64>(I64) then
        Result := I64
    end;
    {$ENDIF}
    tkFloat:
    begin
      if v.TryAsType<Double>(D) then
        Result := D;
    end;
    {$IFDEF WEBLIB}
    tkBool:
    begin
      if v.TryAsType<Boolean>(B) then
        Result := Integer(B);
    end;
    {$ENDIF}
    tkString{$IFNDEF WEBLIB}, tkWString, tkLString, tkUString{$ENDIF}:
    begin
      if TryStrToInt(v.AsString, I) then
        Result := I
      else if TryStrToInt64(v.AsString, I64) then
        Result := I64
      else if TryStrToFloat(v.AsString, D, AFormatSettings) then
        Result := D
      else if TryStrToBool(v.AsString, B) then
        Result := Integer(B);
    end;
  end;
end;

function ValueToDateTime(AValue: TTMSFNCValue): TDateTime;
begin
  Result := ValueToDateTime(AValue, FormatSettings);
end;

function ValueToDateTime(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): TDateTime;
var
  I64: Int64;
  I: Integer;
  D: Double;
  v: TValue;
  B: Boolean;
  dt: TDateTime;
begin
  Result := 0.0;

  v := FNCValueToTValue(AValue);
  if v.IsEmpty then
    Exit;

  case v.Kind of
    tkEnumeration:
    begin
      if v.TryAsType<Boolean>(B) then
        Result := Integer(B)
    end;
    tkInteger:

    begin
      if v.TryAsType<Integer>(I) then
        Result := I
    end;
    {$IFNDEF WEBLIB}
    tkInt64:
    begin
      if v.TryAsType<Int64>(I64) then
        Result := I64
    end;
    {$ENDIF}
    tkFloat:
    begin
      if v.TryAsType<Double>(D) then
        Result := D;
    end;
    {$IFDEF WEBLIB}
    tkBool:
    begin
      if v.TryAsType<Boolean>(B) then
        Result := Integer(B);
    end;
    {$ENDIF}
    tkString{$IFNDEF WEBLIB}, tkWString, tkLString, tkUString{$ENDIF}:
    begin
      if TryStrToInt(Trim(v.AsString), I) then
        Result := I
      else if TryStrToInt64(Trim(v.AsString), I64) then
        Result := I64
      else if TryStrToFloat(Trim(v.AsString), D, AFormatSettings) then
        Result := D
      else if TryStrToDateTime(Trim(v.AsString), dt, AFormatSettings) then
        Result := dt
      else if TryStrToBool(Trim(v.AsString), B) then
        Result := Integer(B);
    end;
  end;
end;

function ValueIsString(AValue: TTMSFNCValue): Boolean;
begin
  Result := (TypeOfValue(AValue) in [tkString{$IFNDEF WEBLIB}, tkWString, tkLString, tkUString{$ENDIF}]);
end;

function ValueIsInteger(AValue: TTMSFNCValue): Boolean;
begin
  Result := (TypeOfValue(AValue) in [tkEnumeration, tkInteger{$IFNDEF WEBLIB},tkInt64{$ENDIF}{$IFDEF WEBLIB}, tkBool{$ENDIF}]);
end;

function ValueIsEmpty(AValue: TTMSFNCValue): Boolean;
var
  v: TValue;
begin
  v := FNCValueToTValue(AValue);
  Result := TValue(v).IsEmpty;

  if ValueIsString(v) then
    Result := Result or (ValueToString(v) = '');
end;

function ValueIsFloat(AValue: TTMSFNCValue): Boolean;
begin
  Result := (TypeOfValue(AValue) in [tkFloat]);
end;

function ValueIsDateTime(AValue: TTMSFNCValue): Boolean;
begin
  Result := ValueIsDateTime(AValue, FormatSettings);
end;

function ValueIsDateTimeType(AValue: TTMSFNCValue): Boolean;
begin
  {$IFDEF WEBLIB}
  Result := (ValueIsFloat(AValue) {and (AValue.TypeInfo.Name = 'TDateTime')});
  {$ENDIF}
  {$IFNDEF WEBLIB}
  Result := (ValueIsFloat(AValue) and (AValue.{$IFNDEF NEXTGEN}TypeInfo.Name{$ELSE}TypeInfo.NameFld.ToString{$ENDIF} = 'TDateTime') or (AValue.{$IFNDEF NEXTGEN}TypeInfo.Name{$ELSE}TypeInfo.NameFld.ToString{$ENDIF} = 'TDate') or (AValue.{$IFNDEF NEXTGEN}TypeInfo.Name{$ELSE}TypeInfo.NameFld.ToString{$ENDIF} = 'TTime'));
  {$ENDIF}
end;

function ValueIsDateTime(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): Boolean;
var
  dt: TDateTime;
begin
  Result := ValueIsDateTimeType(AValue) or (ValueIsString(AValue) and TryStrToDateTime(ValueToString(AValue), dt, AFormatSettings));
end;

function ValueIsBoolean(AValue: TTMSFNCValue): Boolean;
begin
  Result := (TypeOfValue(AValue) in [tkEnumeration{$IFDEF WEBLIB}, tkBool{$ENDIF}]);
end;

function TypeOfValue(AValue: TTMSFNCValue): TTypeKind;
var
  v: TValue;
begin
  Result := tkUnknown;

  v := FNCValueToTValue(AValue);
  if v.IsEmpty then
    Exit;

  Result := v.Kind;
end;

function ValueToString(AValue: TTMSFNCValue): string;
begin
  Result := ValueToString(AValue, FormatSettings);
end;

function ValueToString(AValue: TTMSFNCValue; AFormatSettings: TFormatSettings): string;
var
  {$IFNDEF WEBLIB}
  I64: Int64;
  {$ENDIF}
  D: Double;
  v: TValue;
  I: Integer;
  B: Boolean;
  l: TStrings;
begin
  Result := '';

  v := FNCValueToTValue(AValue);
  if v.IsEmpty then
    Exit;

  case v.Kind of
    tkEnumeration:
    begin
      if v.TryAsType<Boolean>(B) then
        Result := BoolToStr(B, True);
    end;
    tkInteger:
    begin
      if v.TryAsType<Integer>(I) then
        Result := IntToStr(I);
    end;
    {$IFNDEF WEBLIB}
    tkInt64:
    begin
      if v.TryAsType<Int64>(I64) then
        Result := IntToStr(I64)
    end;
    {$ENDIF}
    tkFloat:
    begin
      if v.TryAsType<Double>(D) then
      begin
        {$IFNDEF WEBLIB}
        if v.{$IFNDEF NEXTGEN}TypeInfo.Name{$ELSE}TypeInfo.NameFld.ToString{$ENDIF} = 'TDateTime' then
          Result := DateTimeToStr(D, AFormatSettings)
        else if v.{$IFNDEF NEXTGEN}TypeInfo.Name{$ELSE}TypeInfo.NameFld.ToString{$ENDIF} = 'TDate' then
          Result := DateToStr(D, AFormatSettings)
        else if v.{$IFNDEF NEXTGEN}TypeInfo.Name{$ELSE}TypeInfo.NameFld.ToString{$ENDIF} = 'TTime' then
          Result := TimeToStr(D, AFormatSettings)             
        else
       {$ENDIF}
          Result := FloatToStr(D, AFormatSettings)
      end
    end;
    {$IFDEF WEBLIB}
    tkBool:
    begin
      if v.TryAsType<Boolean>(B) then
        Result := BoolToStr(B, True);
    end;
    {$ENDIF}
    tkString{$IFNDEF WEBLIB}, tkWString, tkLString, tkUString{$ENDIF}: Result := v.AsString;
    tkClass:
    begin
      if v.TryAsType<TStrings>(l) then
        Result := l.Text
      else
        Result := v.ToString;
    end
    else
      Result := v.ToString;
  end;
end;

function IsFNCValueEqual(AValue1: TTMSFNCValue; AValue2: TTMSFNCValue; ATypeKind: TTypeKind = tkUnknown): Boolean;
begin
  Result := CompareFNCValue(AValue1, AValue2, FormatSettings, ATypeKind) = 0;
end;

function IsFNCValueEqual(AValue1: TTMSFNCValue; AValue2: TTMSFNCValue; AFormatSettings:TFormatSettings; ATypeKind: TTypeKind = tkUnknown): Boolean;
begin
  Result := CompareFNCValue(AValue1, AValue2, AFormatSettings, ATypeKind) = 0;
end;

function CompareFNCValue(AValue1: TTMSFNCValue; AValue2: TTMSFNCValue; ATypeKind: TTypeKind = tkUnknown): Integer;
begin
  Result := CompareFNCValue(AValue1, AValue2, FormatSettings, ATypeKind);
end;

function CompareFNCValue(AValue1: TTMSFNCValue; AValue2: TTMSFNCValue; AFormatSettings:TFormatSettings; ATypeKind: TTypeKind = tkUnknown): Integer;
var
  v1,v2: TValue;
  d1,d2: Double;
  I641, I642: Int64;
  i1,i2: Integer;
  dt1, dt2: TDateTime;
begin
  if ValueIsEmpty(AValue1) and ValueIsEmpty(AValue2) then
    Result := 0
  else if ValueIsEmpty(AValue1) then
    Result := -1
  else if ValueIsEmpty(AValue2) then
    Result := 1
  else
  begin
    if ValueIsBoolean(AValue1) and ValueIsBoolean(AValue2) then
    begin
      if ValueToBoolean(AValue1) = ValueToBoolean(AValue2) then
        Result := 0
      else if ValueToBoolean(AValue1) then
        Result := 1
      else
        Result := -1;
    end
    else if ValueIsInteger(AValue1) and ValueIsInteger(AValue2) then
      Result := Math.CompareValue(ValueToInt64(AValue1, AFormatSettings), ValueToInt64(AValue2, AFormatSettings))
    else if ValueIsFloat(AValue1) and ValueIsFloat(AValue2) then
    begin
      if ValueIsDateTime(AValue1, AFormatSettings) and ValueIsDateTime(AValue2, AFormatSettings) then
        Result := CompareDateTime(ValueToFloat(AValue1, AFormatSettings), ValueToFloat(AValue2, AFormatSettings))
      else
        Result := Math.CompareValue(ValueToFloat(AValue1, AFormatSettings), ValueToFloat(AValue2, AFormatSettings))
    end
    else if ValueIsString(AValue1) and ValueIsString(AValue2) then
    begin
      v1 := FNCValueToTValue(AValue1);
      v2 := FNCValueToTValue(AValue2);
      if TryStrToFloat(v1.AsString, d1, AFormatSettings) and TryStrToFloat(v2.AsString, d2, AFormatSettings) then
        Result := Math.CompareValue(d1, d2)
      else if TryStrToInt64(v1.AsString, I641) and TryStrToInt64(v2.AsString, I642) then
        Result := Math.CompareValue(I641, I642)
      else if TryStrToInt(v1.AsString, i1) and TryStrToInt(v2.AsString, i2) then
        Result := Math.CompareValue(i1, i2)
      else if TryStrToDateTime(v1.AsString, dt1, AFormatSettings) and TryStrToDateTime(v2.AsString, dt2, AFormatSettings) then
        Result := CompareDateTime(dt1 ,dt2)
      else
        Result := CompareStr(ValueToString(AValue1), ValueToString(AValue2));
    end
    else
    begin
      v1 := FNCValueToTValue(AValue1);
      v2 := FNCValueToTValue(AValue2);
      Result := CompareStr(v1.ToString, v2.ToString);
    end;
  end;
end;

function TextToFNCValue(AValueText: string; AFormatSettings:TFormatSettings): TTMSFNCValue;
var
  v: TTMSFNCValue;
  d: Double;
  dt: TDateTime;
  i64: Int64;
  i: Integer;
  b: Boolean;
begin
  if TryStrToInt(Trim(AValueText), i) then
    v := i
  else if TryStrToInt64(Trim(AValueText), i64) then
    v := i64
  else if TryStrToFloat(Trim(AValueText), d, AFormatSettings) then
    v := d
  else if TryStrToDateTime(Trim(AValueText), dt, AFormatSettings) then
    v := dt
  else if TryStrToBool(Trim(AValueText), b) then
    v := b
  else
    v := AValueText;

  Result := v;
end;

function TextToFNCValue(AValueText: string): TTMSFNCValue;
begin
  Result := TextToFNCValue(AValueText, FormatSettings);
end;

function FNCValueToString(AValue: TTMSFNCValue): string;
begin
  Result := FNCValueToString(AValue, FormatSettings);
end;

function FNCValueToString(AValue: TTMSFNCValue; AFormatSettings:TFormatSettings): string;
var
  v: TValue;
  d: Double;
  dt: TDateTime;
  i64: Int64;
  i: Integer;
  b: Boolean;
begin
  Result := '';
  if ValueIsBoolean(AValue) then
    Result := BoolToStr(ValueToBoolean(AValue, AFormatSettings), True)
  else if ValueIsInteger(AValue) then
    Result := IntToStr(ValueToInt64(AValue, AFormatSettings))
  else if ValueIsFloat(AValue) then
  begin
    if ValueIsDateTime(AValue,AFormatSettings) then
      Result := DateTimeToStr(ValueToDateTime(AValue,AFormatSettings))
    else
      Result := FloatToStr(ValueToFloat(AValue, AFormatSettings), AFormatSettings)
  end
  else if ValueIsString(AValue)then
  begin
    v := FNCValueToTValue(AValue);

    if TryStrToDate(Trim(v.AsString), dt, AFormatSettings) then
      Result := DateToStr(dt, AFormatSettings)
    else if TryStrToTime(Trim(v.AsString), dt, AFormatSettings) then
      Result := TimeToStr(dt, AFormatSettings)
    else if TryStrToDateTime(Trim(v.AsString), dt, AFormatSettings) then
      Result := DateTimeToStr(dt, AFormatSettings)
    else if TryStrToFloat(Trim(v.AsString), d, AFormatSettings) then
      Result := FloatToStr(d, AFormatSettings)
    else if TryStrToInt64(Trim(v.AsString), i64) then
      Result := IntToStr(i64)
    else if TryStrToInt(Trim(v.AsString), i) then
      Result := IntToStr(i)
    else if TryStrToBool(Trim(v.AsString), b) then
      Result := BoolToStr(b)
    else
      Result := v.ToString;
  end;
end;

{ TTMSFNCValueHelper }

function TTMSFNCValueHelper.Equals(const Value: TTMSFNCValue; AFormatSettings: TFormatSettings): boolean;
begin
  Result := CompareFNCValue(Self, Value, AFormatSettings) = 0;
end;

end.

